import { render, staticRenderFns } from "./IotDevicePortEditDialog.vue?vue&type=template&id=52562561&scoped=true"
import script from "./IotDevicePortEditDialog.vue?vue&type=script&lang=ts"
export * from "./IotDevicePortEditDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52562561",
  null
  
)

export default component.exports